import ModalComponent from "@/common/Modal";
import { OptInModalProps } from "../types";
import { Box, Button, Text, Switch, Divider } from "@chakra-ui/react";
import React, { useState, useEffect } from 'react'
import './OptInForm.scss';
import { jusThisStoreValues, allStoreValues } from '@/utils/constants';
import { EditValuesToBeSavedInterface } from '@/model/editDetails.mjs';
import { getDealerActionsToBeSaved, getIsCreateDealerActionCompleted, getIsCreateDealerActionInprogress } from '@/explore/ducks/selectors';
import { setDealerActionsToBeSaved, setIsCreateDealerActionInprogress, callToCreateDealerAction, setOptinOptoutEdited, setDealerOptOutValue, setIsDealerOptOut } from '@/explore/ducks/slice';
import { DealerProfileType } from '@masterffl/dealer-profile-component';
import { getIsGlobalAdmin, getIsGlobalAdminRole, getIsMyFFLRole, getIsStoreAdmin, getStoreData, getIsGlobalOperationsRole, getIsGlobalOperations } from '@/redux/app-selectors';

import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { callToGetDealerDetail } from "../ducks/slice";

export function OptInForm({ data, onNonFFLToggleChange }: { data: DealerProfileType, onNonFFLToggleChange: (changed: boolean) => void }) {
  const dispatch = useDispatch();
  const isGlobalAdmin = getIsGlobalAdmin();
  const isMyFFLRole = getIsMyFFLRole();
  const dealerActionsToBeSaved = getDealerActionsToBeSaved();
  const isCreateDealerActionCompleted = getIsCreateDealerActionCompleted();
  const isCreateDealerActionInprogress = getIsCreateDealerActionInprogress();
  const isGlobalAdminRole = getIsGlobalAdminRole()
  const isGlobalOperationsRole = getIsGlobalOperationsRole()
  const isGlobalOperations = getIsGlobalOperations();
  const storeData = getStoreData()

  let optOutOptions = ''
  const [optinOptout, setOptinOptout] = useState('');
  const [optOutOptionFor, setOptOutOptionFor] = useState(
    Object.keys(allStoreValues).includes(optOutOptions)
      ? 'all_store'
      : Object.keys(jusThisStoreValues).includes(optOutOptions)
        ? 'just_this_store'
        : ''
  );
  const { isOptInForAll, isOptOutForAll, isOptOutForStore, isOptInForStore, isOptedOutForTransferFromNonFFLSeller = false } = data.businessDetails
  console.log({ isOptInForAll, isOptOutForAll, isOptOutForStore, isOptInForStore, isOptedOutForTransferFromNonFFLSeller });

  // dynamically setting text for a store when toggle state is unchecked/ checked
  const [justThisStoreOption, setJustThisStoreOption] = useState(
    (optOutOptions === 'store') ? 'does not' : 'does'
  );
  // dynamically setting text for all stores when toggle state is unchecked/ checked
  const [allStoreOption, setAllStoreOption] = useState(
    optOutOptions === 'all' ? 'does not' : 'does'
  );
  // set default toggle text when modal opens  
  const [defaultStatusStore, setDefaultStatusStore] = useState(true);
  const [defaultStatusAllStore, setDefaultStatusAllStore] = useState(true);
  const [defaultStatusNonFFL, setDefaultStatusNonFFL] = useState(!isOptedOutForTransferFromNonFFLSeller);
  const [isNonFFLToggleChanged, setIsNonFFLToggleChanged] = useState(false);

  useEffect(() => {
    if (isCreateDealerActionCompleted && !isCreateDealerActionInprogress) {
      if (optinOptout) {
        dispatch(setOptinOptoutEdited(optinOptout));
        dispatch(setDealerOptOutValue(optinOptout));
        dispatch(setIsDealerOptOut(optinOptout === 'all' || optinOptout === 'store'));
      }
    }
  }, [isCreateDealerActionCompleted]);

  const updateFinalOptinOptoutValue = () => {
    let optiOptout = '';
    if (optOutOptionFor === 'just_this_store') {
      if (justThisStoreOption === 'does not') optiOptout = 'store';
      else if (justThisStoreOption === 'does') optiOptout = 'opt_in_store';
    }
    if (optOutOptionFor === 'all_store') {
      if (allStoreOption === 'does') optiOptout = 'opt_in_all';
      else if (allStoreOption === 'does not') optiOptout = 'all';
    }
    const params = {
      value: optiOptout,
      name: 'optin_optout_value',
      license_key: data.primaryInboundDetails.licenseKey,
      type: 'add'
    };
    setOptinOptout(optiOptout);
    if (optiOptout && optiOptout != optOutOptions) {
      updateDealerAction(params);
    }
    else {
      updateDealerAction(params, true);
    }
  };

  const updateDealerAction = (
    editParams: EditValuesToBeSavedInterface,
    isAlreadyExist?: boolean
  ) => {
    if (isAlreadyExist) {
      const actions = dealerActionsToBeSaved.filter(
        action => action.name != editParams.name
      );
      dispatch(setDealerActionsToBeSaved(actions));
      return;
    }
    let recordExist = false;
    const actions = dealerActionsToBeSaved.map(action => {
      if (action.name === editParams.name && (typeof action.value === typeof editParams.value)) {
        recordExist = true;
        return editParams;
      }
      return action;
    });
    if (recordExist) dispatch(setDealerActionsToBeSaved(actions));
    else
      dispatch(
        setDealerActionsToBeSaved([...dealerActionsToBeSaved, editParams])
      );
  };

  // on change toggle state for all stores and single store   
  const onChangeOptinOptoutJustThisStore = (event: any, type: string) => {
    setOptOutOptionFor(type)
    if (type === 'just_this_store') {
      if (event.target.checked) setJustThisStoreOption('does'); //Optin for this store
      else setJustThisStoreOption('does not');  //Opt out for this store
    }
    if (type === 'all_store') {
      if (event.target.checked) setAllStoreOption('does'); //Optin for all stores 
      else {
        setAllStoreOption('does not');
      } //Optout for all stores
    }
  };

  // on change toggle state for non-FFL transfers
  const onChangeNonFFLToggle = (event: any) => {
    setDefaultStatusNonFFL(event.target.checked);
    setIsNonFFLToggleChanged(true);
    
    // Add the non-FFL dealer action to be saved
    const params = {
      value: { isOptedOutForTransferFromNonFFLSeller: !event.target.checked },
      name: 'optin_optout_value',
      license_key: data.primaryInboundDetails.licenseKey,
      type: 'add'
    };
    updateDealerAction(params);
  };

  useEffect(() => {
    updateFinalOptinOptoutValue();
  }, [optOutOptionFor, justThisStoreOption, allStoreOption]);

  useEffect(() => {
    onNonFFLToggleChange(isNonFFLToggleChanged);
  }, [isNonFFLToggleChanged, onNonFFLToggleChange]);
  return (
    <Box>
      <Box className="update_preferences_text">
        <Text className="update_preferences_title">Update this dealer’s opt-in preferences.</Text>
      </Box>
      <Box className="toggle_section_wrapper">
        {(isGlobalAdmin || isGlobalOperations || isMyFFLRole) ? <Box className="toggle_section">
          <Text>Dealer <Text as='b'>
            {defaultStatusAllStore
              ? isOptInForAll ? 'does' : 'does not'
              : allStoreOption === 'does not' ? 'does not' : 'does'}</Text> accept transfers from  <Text as='b'>all stores</Text>!</Text>
          <Switch color={'red'} size='lg' onChange={(event: any) => {
            setDefaultStatusAllStore(false);
            onChangeOptinOptoutJustThisStore(
              event,
              'all_store'
            )
          }}
            isInvalid={!isOptInForAll && !isOptOutForAll}
            isChecked={defaultStatusAllStore ? (isOptInForAll ? true : false) : allStoreOption === 'does'}
            sx={{
              '& .chakra-switch__track': { bg: 'red.100' }, // Track color when unchecked
              '& .chakra-switch__thumb': { bg: 'red.600', border: '2px', borderColor: 'red.100' }, // Thumb color when unchecked
              '.chakra-switch__track[data-checked]:not([data-theme])': { backgroundColor: 'green.100', },
              '.chakra-switch__thumb[data-checked]:not([data-theme])': { backgroundColor: 'green.400', border: '2px', borderColor: 'green.100' },
            }}
          />
        </Box> : <Box className="toggle_section">
          <Text>Dealer <Text as='b'>
            {defaultStatusStore
              ? isOptInForStore ? 'does' : 'does not' //default status when modal is opened
              : justThisStoreOption === 'does not' ? 'does not' : 'does'}</Text> accept transfers with our store</Text>
          <Switch color={'red'} size='lg' onChange={(event: any) => {
            setDefaultStatusStore(false);
            onChangeOptinOptoutJustThisStore(
              event,
              'just_this_store'
            )
          }}
            isInvalid={!isOptInForStore && !isOptOutForStore}
            isChecked={defaultStatusStore ? (isOptInForStore ? true : false) : justThisStoreOption === 'does'}
            sx={{
              '& .chakra-switch__track': { bg: 'red.100' }, // Track color when unchecked
              '& .chakra-switch__thumb': { bg: 'red.600', border: '2px', borderColor: 'red.100' }, // Thumb color when unchecked
              '.chakra-switch__track[data-checked]:not([data-theme])': { backgroundColor: 'green.100', },
              '.chakra-switch__thumb[data-checked]:not([data-theme])': { backgroundColor: 'green.400', border: '2px', borderColor: 'green.100' },
            }}
          />
        </Box>}
      </Box>
      {(isGlobalAdminRole || isGlobalOperationsRole || storeData?.is_multi_tenant) ? <Box className="toggle_section_wrapper">
        <Box className="toggle_section">
          <Text>Do you accept transfers from <Text as='b'>non-FFL's</Text>?</Text>
          <Switch color={'red'} size='lg' onChange={onChangeNonFFLToggle}
            isChecked={defaultStatusNonFFL}
            sx={{
              '& .chakra-switch__track': { bg: 'red.100' }, // Track color when unchecked
              '& .chakra-switch__thumb': { bg: 'red.600', border: '2px', borderColor: 'red.100' }, // Thumb color when unchecked
              '.chakra-switch__track[data-checked]:not([data-theme])': { backgroundColor: 'green.100', },
              '.chakra-switch__thumb[data-checked]:not([data-theme])': { backgroundColor: 'green.400', border: '2px', borderColor: 'green.100' },
            }}
            isDisabled={allStoreOption === 'does not' || justThisStoreOption === "does not"}
          />
        </Box>
      </Box> : <></>}
      <Divider style={{ width: '90%', margin: 'auto' }} />
    </Box>
  );
}

export default function OptInModal({
  isOpen,
  onClose,
  data
}: OptInModalProps) {
  const dispatch = useDispatch()
  const params: any = useParams()
  const dealerActionsToBeSaved = getDealerActionsToBeSaved();
  const isCreateDealerActionInprogress = getIsCreateDealerActionInprogress();
  const isCreateDealerActionCompleted = getIsCreateDealerActionCompleted()
  const [isNonFFLToggleChanged, setIsNonFFLToggleChanged] = useState(false);

  const defaultValue = dealerActionsToBeSaved.map(item => item.value)[0]
  const { isOptInForAll, isOptOutForAll, isOptOutForStore, isOptInForStore } = data.businessDetails
  let value = ''
  if (isOptOutForStore) value = 'store';
  else if (isOptInForStore) value = 'opt_in_store';
  else if (isOptInForAll) value = 'opt_in_all';
  else if (isOptOutForAll) value = 'all';

  const onSaveHandler = async () => {
    dispatch(setIsCreateDealerActionInprogress(true))
    dispatch(callToCreateDealerAction({ actionList: dealerActionsToBeSaved }));
  };

  useEffect(() => {
    if (!isCreateDealerActionInprogress && isCreateDealerActionCompleted) {
      dispatch(callToGetDealerDetail(params?.dealerId));
      onClose()
    }
  }, [isCreateDealerActionCompleted, isCreateDealerActionInprogress])

  return (
    <ModalComponent
      title="Opt In"
      isOpen={isOpen}
      onClose={onClose}
      variant={2}
      className="btns"
      footer={
        <Box className="opt-in-footer">
          <Button
            className="cancel_btn"
            onClick={() => {
              onClose();
            }}
            isDisabled={isCreateDealerActionInprogress}
          >
            Cancel
          </Button>
          <Button
            className="save_btn"
            colorScheme="blue"
            background="#0C1E46"
            padding="8px 20px"
            onClick={onSaveHandler}
            isLoading={isCreateDealerActionInprogress}
            isDisabled={!isNonFFLToggleChanged && (dealerActionsToBeSaved.length <= 0 || value === defaultValue)}
          >
            Save
          </Button>
        </Box>
      }

    >
      <OptInForm data={data} onNonFFLToggleChange={setIsNonFFLToggleChanged} />

    </ModalComponent>
  )
}
